const pages = {
  index: '/',
  home: '/home/(.*)?',
};

export default pages;
